function checkProducts(location) {
  const productGrid = document.querySelector('ul.product-grid');
  const notAvailable = document.querySelector('.no_availability');
  const locationTag = document.querySelector(
    `input[value="location:${location}"]`
  );

  if (locationTag) {
    notAvailable.classList.add('hidden');
    locationTag.click();

    //  const url = window.location.href;
    //   const search = `?filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=location:${locationValue.toLowerCase()}&sort_by=title-ascending`;
    //   history.replaceState({page: url }, url, search);
    //   const URL = `${window.location.pathname}?section_id={{ section.id }}&?filter.v.price.gte=&filter.v.price.lte=&filter.p.tag=location:${locationValue.toLowerCase()}&sort_by=title-ascending`;

    //   fetch(URL)
    //     .then((response) => response.text())
    //     .then((responseText) => {
    //       const html = responseText;
    //       console.log(html);
    //       const productContainer = new DOMParser().parseFromString(html, 'text/html').querySelector('#ProductGridContainer ul').innerHTML;

    //       document.querySelector("#product-grid").innerHTML = productContainer;
    //   });
  } else {
    document.getElementById('ProductCount').innerHTML = '0 product';
    document.getElementById('ProductCountDesktop').innerHTML = '0 product';
    productGrid.classList.add('hidden');
    notAvailable.classList.remove('hidden');
  }
}
